import type { ReactNode } from "react";

type Tone = "neutral" | "success" | "warning" | "error";

const toneStyles: Record<Tone, string> = {
  neutral: "bg-slate-100 text-ink-soft",
  success: "bg-green-100 text-green-700",
  warning: "bg-amber-100 text-amber-700",
  error: "bg-red-100 text-red-700",
};

interface MessageScreenProps {
  tone?: Tone;
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
}

/** Centered terminal/info screen used for success, cancel, error, and not-found. */
export function MessageScreen({
  tone = "neutral",
  icon,
  title,
  description,
  children,
}: MessageScreenProps) {
  return (
    <div className="mx-auto flex w-full max-w-xl flex-1 flex-col items-center justify-center px-5 py-16 text-center">
      <div
        className={`mb-6 flex h-16 w-16 items-center justify-center rounded-full ${toneStyles[tone]}`}
        aria-hidden="true"
      >
        {icon ?? <span className="text-2xl font-bold">i</span>}
      </div>
      <h1 className="text-2xl font-bold text-ink sm:text-3xl">{title}</h1>
      {description ? (
        <div className="mt-3 max-w-md text-lg text-ink-soft">{description}</div>
      ) : null}
      {children ? <div className="mt-8">{children}</div> : null}
    </div>
  );
}
